import React from 'react';
import './TransparencyGuarantee.scss';
import { useAnimateOnScroll } from '../../Utils/hooks/useAnimateOnScroll';

import frameBackground from '../../Assets/images/transparency_guarantee_frame.png';
import leftLine from '../../Assets/images/transparency_guarantee_left_line.png';
import rightLine from '../../Assets/images/transparency_guarantee_right_line.png';
import eyeIcon from '../../Assets/images/transparency_guarantee_eye.png';
import volumeIcon from '../../Assets/images/transparency_guarantee_volume.png';
import deductionIcon from '../../Assets/images/transparency_guarantee_volume_deduction.png';

const guarantees = [
  {
    id: 'spreads',
    icon: eyeIcon,
    alt: 'No hidden spreads icon',
    label: 'No hidden spreads',
  },
  {
    id: 'volume',
    icon: volumeIcon,
    alt: 'No volume traps icon',
    label: 'No volume traps',
  },
  {
    id: 'deductions',
    icon: deductionIcon,
    alt: 'No surprise deductions icon',
    label: 'No surprise deductions',
  },
];

const TransparencyGuarantee = () => {
  const titleRef = useAnimateOnScroll();
  const itemsRef = useAnimateOnScroll();

  return (
    <section
      className="transparency-guarantee"
      style={{ backgroundImage: `url(${frameBackground})` }}
    >
      <div className="container">
        <div ref={titleRef} className="transparency-guarantee__header slide-down">
          <h2 className="transparency-guarantee__title">
            The 5% Transparency{' '}
            <span className="transparency-guarantee__title-highlight">
              Guarantee
            </span>
          </h2>

          <div className="transparency-guarantee__subtitle">
            <img
              src={leftLine}
              alt=""
              aria-hidden="true"
              className="transparency-guarantee__line"
            />
            <p className="transparency-guarantee__subtitle-text">
              By eliminating the traditional broker, we maximize profits for
              every partner.
            </p>
            <img
              src={rightLine}
              alt=""
              aria-hidden="true"
              className="transparency-guarantee__line"
            />
          </div>
        </div>

        <div ref={itemsRef} className="transparency-guarantee__items slide-up">
          {guarantees.map((item) => (
            <div key={item.id} className="transparency-guarantee__item">
              <img
                src={item.icon}
                alt={item.alt}
                className="transparency-guarantee__item-icon"
              />
              <p className="transparency-guarantee__item-label">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TransparencyGuarantee;
